import React from 'react'
import { TouchableOpacity, ViewStyle } from 'react-native'
import { CheckBox, CheckBoxProps } from '@ui-kitten/components'
import { BtText } from './BtText'
import { createEditable } from '../helpers'

export interface BtCheckBoxProps
  extends Omit<CheckBoxProps, 'onPress' | 'onChange'> {
  label?: string
  labelLeft?: boolean
  onPress?: (val: boolean) => void
  style?: ViewStyle
  disabled?: boolean
}

const BtCheckBox_ = ({
  style,
  onPress,
  checked,
  label,
  labelLeft = false,
  disabled = false,
  ...rest
}: BtCheckBoxProps) => {
  const onSelect = () => {
    if (!disabled && onPress) {
      onPress(!checked)
    }
  }
  return (
    <TouchableOpacity
      style={[{ flexDirection: 'row', alignItems: 'center' }, style]}
      onPress={onSelect}
      disabled={disabled}
    >
      {labelLeft && <BtText style={{ marginRight: 10 }}>{label}</BtText>}
      <CheckBox
        checked={checked}
        onChange={onSelect}
        disabled={disabled}
        {...rest}
      />
      {!labelLeft}
      {!!label && <BtText style={{ marginLeft: 10 }}>{label}</BtText>}
    </TouchableOpacity>
  )
}

export const BtCheckBox = createEditable({
  Component: BtCheckBox_,
  valuePropertyName: 'checked',
  changePropertyName: 'onPress',
})
